export default __webpack_public_path__ + "static/media/birdem.0141e716.jpeg";